import { UploadType } from '../../components/core/UploadArea';
import { IG4DefaultParams } from '../analytics-gtm/types';

export enum ConverterAnalyticsEventType {
  PAGE_OPEN = 'page_open',
  PAGE_CLICK = 'page_click',
  FILE_UPLOAD = 'file_upload',
  IMAGE_DOWNLOAD = 'image_download',
  FILE_PREVIEW = 'file_preview',
  FILE_DELETE = 'file_delete',
  POPUP_OPEN = 'popup_open',
  POPUP_ACTION = 'popup_action',
}

export enum ConverterPageType {
  LANDING_PAGE = 'landing_page',
  PREVIEW = 'preview',
  EMPTY = 'empty',
  RESULTS = 'results',
  ERROR = 'error',
}

export type FileFormat = string;

export interface IFileUploadParams extends IG4DefaultParams {
  file_format?: FileFormat;
  upload_type: UploadType;
  source?: number | string;
}

export interface IImageDownloadParams extends IG4DefaultParams {
  file_count?: number;
}

export type ConverterG4Params = IG4DefaultParams | IFileUploadParams | IImageDownloadParams;
